const Home = () => {
  return <div>HOME PAGE</div>;
};

export default Home;
